import { Client, ClientCheckRequest, ClientRequest, ClientSuggestRequest, UserUpdateRequest } from 'type/client'
import { Identity } from 'type/Identity'
import { InferenceFeedbackRequest } from 'type/Inference'
import { SizesRequest, SizesResponse } from 'type/size'
import { State } from 'type/state'
import { buildGetQuery, Data, toBody } from 'util/api'
import { fetchJson, Tune } from 'util/fetch'

export class ApiController {
  async getState(slug: string): Promise<State | undefined> {
    try {
      return await this.get<any>('/api/state', { slug })
    } catch {
      return undefined
    }
  }

  async findClient(request: ClientRequest): Promise<Client | undefined> {
    try {
      const response: Client[] = await this.get('/api/user/search', request)
      return response[0]
    } catch (e) {
      console.error('find client failed', e)
      return undefined
    }
  }

  async findClients(request: ClientSuggestRequest): Promise<Client[]> {
    try {
      return await this.get('/api/user/suggest', request)
    } catch (e) {
      console.error('find client failed', e)
      return []
    }
  }

  async getClient(user_id: string): Promise<Client | undefined> {
    try {
      return await this.get('/api/user/get', { user_id })
    } catch (e) {
      console.error('get client failed', e)
    }
  }

  async getIdentities(user_id: string): Promise<Identity[] | undefined> {
    try {
      return await this.get('/api/identities', { user_id })
    } catch (e) {
      console.error('get identities failed', e)
    }
  }

  async checkUser(request: ClientCheckRequest): Promise<boolean> {
    try {
      const { exists } = await this.post<any>('/api/user/check', request)
      return !!exists
    } catch {
      return false
    }
  }

  async createUser(request: any): Promise<Client> {
    return this.post('/api/user/create', request)
  }

  async updateUser(request: UserUpdateRequest): Promise<Client> {
    return this.post('/api/user/update', request)
  }

  async download(url: string): Promise<Blob> {
    return await this.post('/api/download', { url }, { extract: r => r.blob() })
  }

  async sendEvent(event: Record<string, any>): Promise<void> {
    await this.post('/api/stand/event', event)
  }

  async sendAbuse(event: InferenceFeedbackRequest): Promise<void> {
    await this.post('/api/outfits/abuse', event)
  }

  private async get<T>(path: string, data?: Data, tune?: Tune<T>): Promise<T> {
    const query = buildGetQuery(path, data)
    return this.fetch('GET', query, {}, tune)
  }

  private async post<T>(path: string, data?: Data, tune?: Tune<T>): Promise<T> {
    const body = toBody(data)
    return this.fetch('POST', path, { body }, tune)
  }

  private async fetch<T>(method: string, path: string, options: RequestInit, tune?: Tune<T>): Promise<T> {
    return fetchJson<T>(path, { method, ...options }, tune)
  }

  async getSizes(request: SizesRequest): Promise<SizesResponse> {
    return await this.get<SizesResponse>('/api/sizes', request)
  }
}

export const api = new ApiController()
